<template>
  <div class="container pdet">
    <div class="row">
      <div class="col" style="display: flex; justify-content: right;">
        <img :src="path + 'img/portalinformacion.png'" alt="" width="300" />
      </div>
    </div>
    <div class="row pt-0 pb-0" id="top-title">
      <div class="col pl-0">
        <v-card>
          <v-card-title class="grey lighten-4" primary-title>
            <v-layout row justify-space-between class="pl-4 pr-4">
              <span class="text-semibold">Avances en iniciativas PATR</span>
              <span v-if="total_iniciativas"
                >Total de iniciativas PATR: 
                <span class="text-semibold">{{
                  numFormat(total_iniciativas)
                }}</span></span
              >
            </v-layout>
          </v-card-title>
        </v-card>
      </div>
    </div>

    <div class="row" >
      <div class="col-5 p-0 pl-0 d-flex align-items-center justify-content-center" >
        <div id="chartdiv"></div>
      </div>
      <div class="col text-justify">
        <div class="row">
          <div class="col-4 text-right mt-2 pt-5">
            <span class="text-semibold b-block" >Filtrar por Subregión PDET:</span>
          </div>
          <div class="col">
            <v-combobox v-model="region" :items="regiones" label="Seleccione una subregión" @change="regionSelected" >
              <template v-slot:item="{ item }">
                <span :style="'background-color: ' + item.color" class="pdet-region-color" >
                </span>
                <span>{{ item.nombre }}</span>
              </template>
              <template v-slot:selection="data">
                <span
                  :style="'background-color: ' + data.item.color"
                  class="pdet-region-color"
                >
                </span>
                <span>{{ data.item.nombre }}</span>
              </template>
            </v-combobox>
          </div>
        </div>

        <div class="row pb-2 pt-2">
          <div class="col pb-4" v-if="!gridShow">
            <div
              class="mt-0 text-center" v-if="itemSelected && giniciativasbypilaresconruta.length > 0"
            >
              <span class="tit-green text-semibold d-block pb-1"
                >SUBREGIÓN {{ itemSelected.NOM_SUBREG }}</span
              >
              <span class="mt-1 tit-black text-semibold d-block"
                >{{ numFormat(parcial_iniciativas)  }} INICIATIVAS PATR</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col pb-4" v-if="gridShow">
            <div class="col tit-blue">Estado {{ numFormat(Iniciativas_Filtras) }} iniciativas</div>
            <div class="col col-grid-mid">
              <v-data-table
                no-data-text="Sin datos"
                :width="200"
                :headers="headers_ini"
                :items="giniciativasbypilaresconruta"
                class="elevation-2"
                hide-default
                :items-per-page="5"
              >
                <template v-slot:[`item.action1`]="{ item }">
                  <v-icon small @click="detalle(item)"
                    >fa-map-marker-alt</v-icon
                  >
                </template>
              </v-data-table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col pb-4" v-if="gridShow && ocultar">
            <div class="col-9 tit-green">
              Estado de los proyectos (3.500) asociados a las iniciativas con
              ruta activa (2.000)
            </div>
            <div class="col col-grid-mid">
              <v-data-table
                no-data-text="Sin datos"
                :width="200"
                :headers="headers_ini"
                :items="gproyectosbypilares"
                class="elevation-2"
                hide-default
                :items-per-page="5"
              >
                <template v-slot:[`item.action1`]="{ item }">
                  <v-icon small @click="detalle(item)"
                    >fa-map-marker-alt</v-icon
                  >
                </template>
              </v-data-table>
            </div>
          </div>
        </div>

        <div class="row" v-if="!gridShow && giniciativasbypilaresconruta.length > 0">
          <div
            class="col-3"
            v-for="(item, idx) in giniciativasbypilaresconruta"
            :key="idx"
          >
            <span class="patr-icon">
              <span class="img"
                ><img :src="path + 'img/patr-0' + item.idpilarpdet + '.png'"
              /></span>
              <span class="number">{{ numFormat(item.conteo) }}</span>
              <span class="tit">{{ item.nombre.toUpperCase() }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    
    
            
    <v-flex xs12 sm12>  
      <v-alert dense text colored-border elevation="2" border="left" color="primary" >
        <v-layout row >
          <v-flex xs12 sm6>  
            <br>
            <div class="col tit-green">Para conocer el detalle de las iniciativas haga clic en la imagen.   
              <v-icon  class="mr-2" >fa-solid fa-hand-point-right</v-icon>
            </div>
            
          </v-flex>
          <v-flex xs12 sm6>  
            <div class="col tit text-center" >
              <a href="https://centralpdet.renovacionterritorio.gov.co/avance-en-iniciativas/" target="_blank">
              <img :src="path + 'img/portalinformacion.png'" alt="" height="70" />
              </a>
            </div>
          </v-flex>

        </v-layout>
        
      </v-alert>
    </v-flex>
      


    <div class="row mt-0 pt-0" v-if="!gridShow && gestadosbysubregiones.length > 0" v-show="ocultar">
      <div class="col-9 tit-green">
        Estado de los proyectos (40.500) asociados a las iniciativas con ruta
        activa (30.000)
      </div>
      <div class="col-3 text-right">
        <span class="text-semibold">Corte:</span> 30 de junio de 2021
      </div>
    </div>
    <div class="row mt-0 pt-0" v-if="gestadosbysubregiones.length > 0" v-show="ocultar" >
      <div class="col tit-mid text-nowrap bg-green-100 text-center">
        En estructuración: {{ numFormat( ObtenerEstado(2) ) }}
      </div>
      <div class="col tit-mid text-nowrap bg-green-200 text-center">
        Estructurados: {{ numFormat( ObtenerEstado(4) ) }}
      </div>
      <div class="col tit-mid text-nowrap bg-green-300 text-center">
        Estructurados&nbsp;y&nbsp;financiados:&nbsp;{{
          numFormat( ObtenerEstado(5) )
        }}
      </div>
      <div class="col tit-mid text-nowrap bg-green-400 text-center">
        En ejecución: {{ numFormat( ObtenerEstado(1) ) }}
      </div>
      <div class="col tit-mid text-nowrap bg-green text-center">
        Terminados: {{ numFormat( ObtenerEstado(3) ) }}
      </div>
    </div>
    <div class="row mt-0 pt-0" v-if="!gridShow && giniciativasbyregion.length > 0" >
      <div class="col text-center">
        <a href="#" @click="detallePatr()">Conozca el avance detallado de las iniciativas PDET</a>
      </div>
    </div>

    <div class="row mt-6" id="grilla-indicadores" v-if="giniciativasbyregion && giniciativasbyregion.length > 0 && gridShow  && ocultar">
      <div class="col pl-0 pr-0">
        <v-card>
          <v-card-title>
            <div v-if="region">
              Iniciativas para la region de {{ region.nombre }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              no-data-text="Sin datos"
              :headers="headers"
              :items="giniciativasbyregion"
              class="elevation-2"
              hide-default
              :items-per-page="5"
            >

              <template v-slot:[`item.action1`]="{ item }">
                <v-icon small @click="detalle(item)">fa-map-marker-alt</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/pdet.scss";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import departamentos_geo from "../../../public/geo/dpto1.json";
import departamentos_geo_sa from "../../../public/geo/dpto-sa.json";
import regiones_geo from "../../../public/geo/reg.json";
am4core.options.autoSetClassName = true;

import { mapActions, mapGetters } from "vuex";
//import func from 'vue-editor-bridge';

export default {
  name: "IniciativasPDET",
  created() {
    this.textosTodos();
    //======================
    this.get_puntos();
    this.get_iniciativasbypilaresconruta({ params: { idsubregion: 0 }, }); 
    this.getSubregiones({ params: { pdet: true, todas: false, }, }); 
    this.getSubregionesbyiniciativa();
    this.getDepartamentos();  
    this.getMunicipiosbyelemento({ params: { idsubregion: 0, iddepartamento: 0, }, });     

  },
  computed: {
    ...mapGetters([
      "gcontenido_pdet", 
      "gSubregiones",
      "gDepartamentos",
      "gMunicipiosByelemento",  
      "gestadosbysubregiones",
      "giniciativasbypilaresconruta",
      "gpuntos",
      "gproyectosbypilares",
      "giniciativasbyregion",
      "gSubregionesbyiniciativas"
      ]),
  },
  data: () => ({
    ocultar: false,
    departamentos_geo,
    departamentos_geo_sa,
    regionSerie: null,
    map: null,
    gridShow: false,
    region: null,
    indicadores: null,
    indicadores_ini: null,
    regiones: [],
    pilares: [],
    region_pilar: null,
    region_pilares: [],
    total_iniciativas: null,
    parcial_iniciativas: 0,
    Iniciativas_Filtras: null,
    puntos: [],
    patr: [],
    departamentos: [],
    regiones_geo,
    departamentos_todos: [],
    municipios: [],
    municipios_todos: [],
    itemSelected: null,
    path: process.env.BASE_URL,
    caja1: {},
    headers: [
      
      { text: "Pilar", value: "pilar", fixed: true, width: "100px" },
      { text: "No", value: "codigoiniciativapdet", fixed: true, width: "100px" },
      { text: "Iniciativa", value: "titulo", width: "35%" },
      
      { text: "Proyectos", value: "conteoProyectos", width: "110px" },
      { text: "Detalle", value: "action1", sortable: false, align: "center" },
    ],
    headers_ini: [
      { text: "Pilar PDET", value: "nombre" },
      { text: "Con ruta activa", value: "conteoruta", fixed: true, width: "100px", },
      // { text: "Implementadas", value: "implementados",fixed: true, width: "100px", },
    ],
    headers_pry: [
      { text: "Pilar PDET", value: "pilar", fixed: true, width: "120px" },
      {
        text: "Con ruta activa",
        value: "activas",
        fixed: true,
        width: "100px",
      },
      {
        text: "Implementadas",
        value: "implementadas",
        fixed: true,
        width: "100px",
      },
    ],
  }),
  methods: {
    ...mapActions([
      "get_iniciativasbypilaresconruta",
      "getSubregiones",
      "getDepartamentos",
      "getMunicipiosbyelemento",  
      "get_estadosbysubregiones",   
      "get_puntos",
      "get_proyectosbypilares",
      "get_iniciativasbyregion",
      "getSubregionesbyiniciativa"
    ]),    
    ...mapActions("pdet/", ["getData", "getGeo"]),
    ...mapActions(["textosTodos"]),
    detallePatr() {
      this.gridShow = true;
    },
    numFormat(num) {
      if (num == undefined)
        num = 0;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    set_region(region_id) {
      this.regionSelected(this.get_region({ COD_SUBREG: region_id }));
    },
    get_region(data) {
      let item = this.regiones.find((o) => o.idsubregion == data.COD_SUBREG);
      return typeof item !== "undefined" ? item : null;
    },
    regionSelected(e) {
      this.region = e;
      this.gridShow = false;
      this.get_iniciativasbypilaresconruta({ params: { idsubregion: this.region.idsubregion }, }); 
      this.get_iniciativasbyregion({ params: { idsubregion: this.region.idsubregion }, }); 
      this.get_estadosbysubregiones({ params: { idsubregion: this.region.idsubregion }, }); 
      this.get_proyectosbypilares({ params: { idsubregion: this.region.idsubregion }, }); 
      let reg = this.regionSerie.getPolygonById(this.region.idsubregion);
      if (typeof reg !== "undefined") {
        reg.isHover = true;
        this.itemSelected = reg.dataItem.dataContext;
        this.municipios = this.municipios_todos.filter(
          (o) => o.idsubregion == this.region.idsubregion
        );

        const dpto_ids = [ ...new Set(this.municipios.map((item) => item.iddepartamento)),
        ];
        this.departamentos = this.departamentos_todos.filter((o) =>
          dpto_ids.includes(o.iddepartamento)
        );
      }
    },
    makeChart() {
      var chart = am4core.create("chartdiv", am4maps.MapChart);
      
      chart.projection = new am4maps.projections.Miller();
      chart.seriesContainer.draggable = false;
      chart.seriesContainer.resizable = false;
      chart.maxZoomLevel = 1;

      // Dptos
      let dptoSerie = chart.series.push(new am4maps.MapPolygonSeries());
      dptoSerie.geodataSource.url = this.path + "geo/dpto1.json";
      //dptoSerie.useGeodata = true;
      dptoSerie.reverseGeodata = true;
      let polygonTemplate = dptoSerie.mapPolygons.template;
      // polygonTemplate.tooltipText = "{DPTO_CNMBR} ({DPTO_CCDGO})";
      polygonTemplate.fill = am4core.color("#eeeeee");
      polygonTemplate.stroke = am4core.color("#999999");
      polygonTemplate.strokeWidth = 1;
      polygonTemplate.nonScalingStroke = true;
      
      // Regiones
      // https://www.amcharts.com/docs/v4/reference/mappolygonseries/
      this.regionSerie = chart.series.push(new am4maps.MapPolygonSeries());
      this.regionSerie.geodataSource.url = this.path + "geo/reg.json";

      this.regionSerie.events.on("beforedatavalidated", (ev) => {
            ev.target.data.forEach(element => {
              let IniciativaPdte = this.gSubregionesbyiniciativas.filter((p) => p.idsubregion == element.COD_SUBREG )[0]
              if (IniciativaPdte.iniciativas != undefined)
                this.$set(element, "INICIATIVAS", IniciativaPdte.iniciativas )
            });  
      });

      //this.regionSerie.useGeodata = true;
      this.regionSerie.reverseGeodata = true;
      this.regionSerie.calculateVisualCenter = true;
      // regionSerie.mapPolygons.template.showTooltipOn = "always";
      this.regionSerie.mapPolygons.template.tooltipPosition = "fixed";
      // https://www.amcharts.com/docs/v4/reference/mappolygon/#Properties
      let regPolygonTemplate = this.regionSerie.mapPolygons.template;
      regPolygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      regPolygonTemplate.tooltipText = "{NOM_SUBREG} ({INICIATIVAS} iniciativas)";
      regPolygonTemplate.fillOpacity = 0.8;
      regPolygonTemplate.stroke = am4core.color("#666666");
      regPolygonTemplate.strokeWidth = 0;
      regPolygonTemplate.nonScalingStroke = true;
      regPolygonTemplate.adapter.add("fill",  (fill, target) => {
        if (typeof target.dataItem.dataContext !== "undefined") {
          let reg = this.get_region(target.dataItem.dataContext);
          return reg.color;
        }
      });

      regPolygonTemplate.events.on("hit", (ev) => {
        this.regionSelected(this.get_region(ev.target.dataItem.dataContext));
      });

      // Hover state
      let hs = regPolygonTemplate.states.create("hover");
      hs.properties.fillOpacity = 1;

      // chart.zoomControl = new am4maps.ZoomControl();
      chart.events.on("beforedatavalidated", function (ev) {
        console.log("ev.target.data =>", ev.target.data);
      });

      this.map = chart;

    },
    ObtenerEstado(idcodigo) {
      let estado = this.gestadosbysubregiones.filter((o) => parseInt(o.codigo) == idcodigo)[0];
      return estado.conteo;
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.dispose();
    }
  },
  components: {
    // texto,
  },
  watch: {

    giniciativasbypilaresconruta: function () {
      this.Iniciativas_Filtras = 0;
      let total = 0;
      this.parcial_iniciativas = 0;
      this.giniciativasbypilaresconruta.forEach((pilar) => {
        total += pilar.iniciativas;
        this.Iniciativas_Filtras += pilar.conteoruta;
        this.parcial_iniciativas += pilar.conteo;
      });
      if(this.total_iniciativas == null)
        this.total_iniciativas = this.parcial_iniciativas;

      this.regiones_geo.features.forEach((feat) => {
          feat.properties["INICIATIVAS"] = this.numFormat(total);
      });      
    },
    gSubregiones: function () {
      this.regiones = this.gSubregiones;
      this.regiones = [
        { idsubregion: 0, pdet: true, color: "#ffffff", nombre: "TODAS", },
      ].concat(this.regiones);  
    }, 
    gSubregionesbyiniciativas: function () {
      this.makeChart();
    },
    gDepartamentos: function () {
      this.departamentos_todos = this.gDepartamentos;
    },       
    gMunicipiosByelemento: function () {
      this.municipios_todos = this.gMunicipiosByelemento;
    },    
  },
};
</script>
<style scoped>
    #chartdiv {
    width: 100%;
    height: 650px;
    }
</style>
